<template>
  <div class="component-content configuration-tyres">
    <div class="component-content-scroll">
      <div class="component-content-title mb-4">Select your tires</div>

      <option-list
        :options="tyresInput"
        :target="this.results.tyres"
        :inputName="'setpost'"
        v-on:target-updated="updateData"
      ></option-list>
    </div>
    <div class="buttonset">
      <button class="btn btn-outline-dark back-button" v-on:click="goBack">
        back
      </button>
      <finish-configuration-button
        v-if="canFinishConfiguration()"
        v-on:finish-configuration="finishConfiguration"
       ></finish-configuration-button>
      <button class="btn btn-outline-dark next-button" v-on:click="goNext">
        next
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import OptionList from "../../shared/optionList.vue";
import FinishConfigurationButton from './finish-configuration-button.vue';

Vue.component("finish-configuration-button", FinishConfigurationButton);

export default {
  name: "configuration-tyres",
  data() {
    return {};
  },
  components: {
    OptionList,
  },
  props: ["configuratorSteps", "currentStep", "results", "components"],
  methods: {
    goNext: function () {
      if (this.results.tyres==null) {
        this.$emit('set-error', 'Please select a tyre');
        return false;
      }
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
    updateData: function (e) {
      this.tyresInput = e;
    },
    canFinishConfiguration: function() {
// if fork is present, we need to check if the fork is selected and has a colour
        if (this.components.fork?.length > 0) 
        {
          return (
          this.results.frame !== null &&
          this.results.frame !== undefined &&
          this.results.colour !== null &&
          this.results.colour !== undefined &&
          this.results.fork !== null &&
          this.results.fork !== undefined
          );
        }
        else
        {
          // no fork, so we can finish configuration
          return (
            this.results.frame !== null &&
            this.results.frame !== undefined &&
            this.results.colour !== null &&
            this.results.colour !== undefined
          );
        }
    },
    finishConfiguration: function() {
        this.$emit("finish-configuration");
    }
  },
  computed: {
    tyresInput: {
      get: function () {
        return this.components.tyres[0];
      },
      set: function (e) {
        this.$emit("set-tyres", e);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.configuration-tyres {
}
</style>

